import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild ,Input, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { FullscreenComponent } from 'src/app/shared/additional-styles/fullscreen-component';
import { DataService } from 'src/app/shared/services/data.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-department-info-page',
    templateUrl: './department-info-page.component.html',
    styleUrls: ['./department-info-page.component.scss']
})
export class DepartmentInfoPageComponent extends FullscreenComponent implements OnInit {
    constructor(
        private dataService: DataService, 
        private router: Router,
        private routerService: RouterService,
        renderer: Renderer2, 
        @Inject(DOCUMENT) document: Document) 
    {
        super(renderer, document);
    }

    @ViewChild('pageDataContainer') pageDataContainer!: ElementRef;
    @Input() pageNodeId: any;
    @Input() pageTitle: any;
    @Input() departmentInfoId : any;
    @Input() pageUrl: string | null = null;

    componentData: any;
    mainTabsIds: any = [];
    currentMainTab: any;
    currentSubTab: any;
    getDepartmentInfoTabsUrl: string = environment.apiUrl + '/umbraco/Surface/DepartmentInfoSurface/getDepartmentInfoTabs';
    mainTabInitUrl: string = environment.apiUrl + '/umbraco/Surface/DepartmentInfoSurface/MainTabInit';
    isLoading: boolean = false;
    preloaderText: string = '';

    ngOnInit(): void {
        super.setAddithonalStyles();
        if(this.departmentInfoId)
        {
            this.mainTabsIds.push(this.departmentInfoId);
            this.getMainTab();
            return;
        }
        this.getCurrentTabsFromQuery()
        this.getDepartmentInfoTabs();
    }

    ngOnDestroy(): void {
        super.setAddithonalStyles(true);
    }

    getMainTab() {
        var request: any = {
            selectedTabId: this.departmentInfoId ?? (!this.currentMainTab && this.mainTabsIds.length ? this.mainTabsIds[0] : this.currentMainTab),
            mainTabsIds: this.mainTabsIds,
            cultureCode: this.dataService.getCultureCode()
        }
        this.isLoading = true;
        this.dataService.getDataByToken(this.mainTabInitUrl, request).subscribe({
            next: (data) => 
            {
                if(data) {
                    data = JSON.parse(data)
                    this.componentData = data;
                }
                this.isLoading = false;
            },
            error: (e) => console.error(e)
         });
    }

    getCurrentTabsFromQuery() {
        const url = this.router.url;
        const mainTabRegex = /mainTab=(\d+)/;
        const subTabRegex = /subTab=(\d+)/;
      
        const mainTabMatch = url.match(mainTabRegex);
        const subTabMatch = url.match(subTabRegex);
      
        if (mainTabMatch) this.currentMainTab = mainTabMatch[1];
        if (subTabMatch) this.currentSubTab = subTabMatch[1];

    }

    getDepartmentInfoTabs() {
        const url = this.pageUrl?.replace("/private/en/", "") ?? this.routerService.getCurrentComponentRoute()
        var request: any = {
            pageUrl: url,
            cultureCode: this.dataService.getCultureCode()
        }
        this.isLoading = true;
        this.dataService.getDataByToken(this.getDepartmentInfoTabsUrl, request).subscribe({
            next: (data) => 
            {
                if (data) {
                    this.mainTabsIds = data;
                    this.currentMainTab = this.currentMainTab ?? this.mainTabsIds[0];
                    this.getMainTab();
                }
            },  
            error: (e) => console.error(e)
        });
    }
}